 $('.pdp-main-media-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.media-thumbnails-slider'
});
$('.media-thumbnails-slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.pdp-main-media-slider',
  dots: false,
  arrows: false,
  centerMode: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 4
      }
    }
  ]
});


document.addEventListener("DOMContentLoaded", function () {
  const scrollContainer = document.querySelector("#productTab");
  const leftArrow = document.querySelector(".thma-left");
  const rightArrow = document.querySelector(".thma-right");

  if (!scrollContainer || !leftArrow || !rightArrow) return;

  const scrollAmount = 150; // adjust for how much to scroll each click

  leftArrow.addEventListener("click", function () {
    scrollContainer.scrollBy({
      left: -scrollAmount,
      behavior: "smooth"
    });
  });

  rightArrow.addEventListener("click", function () {
    scrollContainer.scrollBy({
      left: scrollAmount,
      behavior: "smooth"
    });
  });
});

